import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { readCoverageHandoff } from '../features/partner-coverage/captureCoverageHandoff';
import { signedInLandingPath } from '../utils/signedInLanding';

// The public pages a signed-in visitor is sent home from. Landing pages
// (/groups, /providers, /crnas) are not among them, to allow traffic
// segmentation.
const PUBLIC_PATHS = ['/', '/login', '/register'];
// Public tool pages and payment returns never redirect.
const TOOL_PATHS = ['/tools'];
const PAYMENT_PATHS = ['/payment-success', '/payment-cancel'];

// App.js Layout: a signed-in visitor who lands on a public page goes home for
// their role. A provider lands on the dashboard, whose journey card leads an
// unfinished provider to the right step (signedInLandingPath). A pending
// coverage handoff wins over the role home.
export default function useSignedInPublicRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext) || {};

  useEffect(() => {
    if (TOOL_PATHS.some((tp) => location.pathname.startsWith(tp))) return;
    if (
      auth?.token &&
      auth?.user?.role &&
      PUBLIC_PATHS.includes(location.pathname) &&
      !PAYMENT_PATHS.some((path) => location.pathname.startsWith(path))
    ) {
      if (readCoverageHandoff()) {
        navigate('/coverage/continue', { replace: true });
        return;
      }
      navigate(signedInLandingPath(auth.user.role), { replace: true });
    }
  }, [auth?.token, auth?.user?.role, location.pathname, navigate]);
}
